import sliderLocationTeaser from '../../../../../../src/js/modules/sliderLocationTeaser';

window.addEventListener('load', () => {
    sliderLocationTeaser.init();
});
